/* Date helpers for chat groupings */
export function formatChatDay(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  const isSameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  if (isSameDay(d, now)) return 'Today';
  if (isSameDay(d, yesterday)) return 'Yesterday';
  const opts = d.getFullYear() === now.getFullYear() ? { day: '2-digit', month: 'short' } : { day: '2-digit', month: 'short', year: 'numeric' };
  return d.toLocaleDateString(undefined, opts);
}

/* Given a list of messages, produce a flat render sequence with day-divider entries.
   Returns entries of shape { type: 'day', label } or { type: 'msg', msg }. */
export function withDayDividers(messages) {
  const out = [];
  let lastDay = null;
  for (const m of messages) {
    const label = formatChatDay(m.at);
    if (label && label !== lastDay) {
      out.push({ type: 'day', label, key: `day-${label}-${m.id}` });
      lastDay = label;
    }
    out.push({ type: 'msg', msg: m, key: m.id });
  }
  return out;
}
